import {useEffect,useState} from 'react';

const useViewSwitcher = (defaultTrigger)=>{

    const [triggerKey,setTriggerKey] = useState('');

    const onUpdateTriggerKey = (ctrlKey) => {
        setTriggerKey(ctrlKey)
    }

    const isComponentVisible = (ctrlKey) => {
        if(triggerKey === ctrlKey)
            return true
        else
            return false
    }

    useEffect(() => {
        setTriggerKey(defaultTrigger);

    }, [defaultTrigger]);
    
    const returnObj = {
        onUpdateTriggerKey,
        isComponentVisible,
        triggerKey
    }

    return returnObj

}

export default useViewSwitcher